import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const getCookie = (cookieName: string): string | undefined => {
  const cookieArray = document.cookie.split(';');
  for (const cookie of cookieArray) {
    const cookieString = cookie.trim();
    if (cookieString.indexOf(cookieName + '=') == 0) {
      return cookieString.substring(cookieName.length + 1, cookieString.length);
    }
  }

  return undefined;
};

export const ebookApi = createApi({
  reducerPath: 'ebookApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers) => {
      const xsrfToken = getCookie('EB-XSRF-TOKEN');
      headers.set('X-EB-XSRF-TOKEN', xsrfToken);

      // Disable caching for all API requests
      headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');
      headers.set('Pragma', 'no-cache');
      headers.set('Expires', '0');

      return headers;
    },
    cache: 'no-store',
  }),
  tagTypes: ['User'],
  endpoints: () => ({}),
});

export const externalTestApi = createApi({
  reducerPath: 'externalTestApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://dummyjson.com' }),
  endpoints: () => ({}),
});
